import React, { useState, useEffect, useRef } from "react";
import {
    Row,
    Col,
    Typography,
    Button,
    message,
    Popconfirm,
    Card,
    ProTableOt,
    Form,
    useProTableOt,
    Accordion, AccordionItem, AccordionTrigger, AccordionContent
} from "../../ui/ot";
import QuestionAndAnswerForm from "./question_and_answer_form";
import parse from 'html-react-parser'; // 解析HTML字串
import { useCRUDController } from "../../ui/classify_structure/CRUDController";
import { text } from "d3";
const { Title, Paragraph, Text, Link } = Typography;
const QuestionAndAnswerAccordion = ({ prefixTitle = "" }) => {
    const questionAndAnswerController = useCRUDController({ apiRoute: "/system/question_and_answer" })
    useEffect(() => {
        questionAndAnswerController.getData({})
        document.title = `${prefixTitle} | 常見問題`

    }, [])
    return (
        <Row gutter={[8, 8]}
            justify={'center'}
            align={'middle'}
            style={{
                padding: "1rem"
            }}
        >
            <Col span={20} style={{ textAlign: "center" }}>
                <Title level={2}>
                    常見問題
                </Title>
            </Col>
            <Col span={20}>
                <Accordion type="single" collapsible>
                    {
                        questionAndAnswerController?.ResponseData.map((val) => {
                            const parsedContent = parse(val.content);
                            return (
                                <AccordionItem value={val?.question_and_answer_id}>
                                    <AccordionTrigger>{val?.title}</AccordionTrigger>
                                    <AccordionContent>
                                        <Row>
                                            <Col span={24}>
                                                {parsedContent}
                                            </Col>
                                        </Row>
                                    </AccordionContent>
                                </AccordionItem>
                            )
                        })
                    }
                </Accordion>

            </Col>
        </Row>)
}
const QuestionAndAnswerTable = ({
    prefixTitle = "",
    showAllColumns = true,
    propsShowColumns,
    mode = "edit",
    rowSelectType = 'checkbox',
    defaultSelectkeys = [], //selectkeys
    defaultSelectInfos = [], //selectInfo
    onSelectChange = () => { }, //selectInfo
    permission_level = null,
}) => {
    const columns = [
        // {
        //     title: "編號",
        //     key: "question_and_answer_id",
        //     dataIndex: "question_and_answer_id",
        //     align: "center",
        // },
        {
            title: "問題標題",
            key: "title",
            dataIndex: "title",
            align: "center",
        },

    ];
    const [showColumns, setShowColumns] = useState(propsShowColumns ? propsShowColumns : ['question_and_answer_data', 'title'])

    const [extra_columns, set_extra_columns] = useState([]);
    const actionRef = useRef();
    const [pageSize, setPageSize] = useState(20);
    const [selectedRowKeys, setSelectedRowKeys] = useState(defaultSelectkeys ? defaultSelectkeys : []);
    const [selectedRowsInfo, setSelectedRowsInfo] = useState(defaultSelectInfos ? defaultSelectInfos : []);
    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = [...selectedRowKeys];
            let selectRow = [...selectedRowsInfo];
            if (selected) {
                changeRows.forEach((value, key) => {
                    select_temp.push(value.question_and_answer_id);
                    selectRow.push(value);
                });
            } else {
                changeRows.forEach((value, key) => {
                    const index = select_temp.indexOf(value.question_and_answer_id);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);
                });
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = [...selectedRowKeys];
            let selectRow = [...selectedRowsInfo];
            if (selected) {
                select_temp.push(record.question_and_answer_id);
                selectRow.push(record);
            } else {
                select_temp = select_temp.filter((key) => key !== record.question_and_answer_id);
                selectRow = selectRow.filter((row) => row.question_and_answer_id !== record.question_and_answer_id);
            }
            setSelectedRowKeys((pre) => select_temp);
            setSelectedRowsInfo(selectRow);
        },

    };
    const [modalOpen, setModalOpen] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);

    const [form] = Form.useForm();

    const [axiosMode, setAxiosMode] = useState("get");
    const onCleanSelected = () => {
        setSelectedRowKeys([]);
        setSelectedRowsInfo([]);
    };
    const handleAddRow = () => {
        setAxiosMode("post");
        setModalOpen(true);
        form.resetFields();

    };
    const handleEditRow = (record) => {
        setAxiosMode("patch");
        setModalOpen(true);

        form.resetFields();
        let editRecord = { ...record }
        if (editRecord) {
            Object.keys(editRecord).forEach((key) => {
                if (key !== "key") {
                    form.setValue(key, editRecord[key]);
                }
            });
        }

    };
    const handleDeleteRow = (id) => {
        let data = [];
        if (id) {
            data = [
                {
                    question_and_answer_id: id,
                },
            ];
        } else {
            data = selectedRowsInfo.map((val) => {
                return {
                    question_and_answer_id: val?.question_and_answer_id,
                };
            });
        }
        if (data.length > 0) {
            questionAndAnswerController.deleteData(data);
        } else {
            message.info("請選擇項目");
        }
    };

    const onFormFinish = (values) => {
        let finalData = { ...values }
        finalData = {
            ...finalData,
        }
        if (axiosMode === "post") {
            questionAndAnswerController.postData([finalData]);
        } else if (axiosMode === "patch") {
            questionAndAnswerController.patchData([finalData]);
        }
    };
    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("新增成功");
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.success("修改成功");
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.success("刪除成功");
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([]);
                setSelectedRowsInfo([]);
            }
        } else if (status === "error") {
            if (axiosMode === "post") {
                message.error("新增失敗");
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.error("修改失敗");
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.error("刪除失敗");
                actionRef.current.reloadAndRest();
            }
        }
        if (axiosMode !== "get") {
            setModalLoading(false);
            setModalOpen(false);
        }
    };
    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true);
    };
    const setParamsFilter = (obj) => {
        //拿掉值為空或是null 的東西
        return Object.entries(obj).reduce(
            (all, [key, value]) =>
                value === "" ? { ...all } : { ...all, [key]: value },
            {}
        );
    };

    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useProTableOt({
        columns,
    });
    const questionAndAnswerController = useCRUDController({
        apiRoute: "/system/question_and_answer", onFinish,
        onBefore
    })

    // const {
    //     getQuestionAndAnswerData,
    //     postQuestionAndAnswerData,
    //     patchQuestionAndAnswerData,
    //     deleteQuestionAndAnswerData
    // } = useQuestionAndAnswer({
    //     onFinish,
    //     onBefore,
    // });

    useEffect(() => {
        checkAll();
    }, []);
    useEffect(() => {
        onSelectChange(selectedRowsInfo)
    }, [selectedRowsInfo])
    return (<Row>

        <Col span={24}>
            <ProTableOt
                formMode={true}
                actionRef={actionRef}
                headerTitle={
                    <>

                    </>
                }
                columns={showAllColumns ? columns : columns.filter((element) => {
                    return showColumns.includes(element?.key)
                })}
                check={check}
                setCheck={setCheck}
                rowKey={"question_and_answer_id"}

                toolBarRender={() => {
                    return []
                }}
                extra_columns={extra_columns}
                set_extra_columns={set_extra_columns}
                manage_columns={false}
                request={async (params = {}, sort, filter) => {
                    setAxiosMode("get");
                    let newParams = {};
                    let order = setOrders(sort);
                    newParams = {
                        ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                        ...newParams,
                        order,
                        size: params?.pageSize,
                        cur_page: params.current,
                        custom_filter_value: params.keyword ?? "",
                        custom_filter_key: custom_filter_key,
                    };
                    newParams = setParamsFilter({
                        ...newParams,
                    });
                    setPageSize(params?.pageSize ?? 20);

                    return questionAndAnswerController.getData(newParams);
                    // return []
                }}
                pageSize={pageSize}
                rowSelection={
                    {
                        type: rowSelectType,
                        selectedRowKeys: selectedRowKeys,
                        selectedRowsInfo: selectedRowsInfo,
                        setSelectedRowKeys: setSelectedRowKeys,
                        setSelectedRowsInfo: setSelectedRowsInfo,
                        ...rowSelection,
                    }
                }
                propsUseData={() => {
                    return {
                        postData: questionAndAnswerController.postData,
                        patchData: (data) => {
                            questionAndAnswerController.patchData(data)
                        },
                        deleteData: questionAndAnswerController.deleteData
                    }
                }}
                PropsPatchForm={<QuestionAndAnswerForm />}
                modalOpen={modalOpen}
                setModalOpen={setModalOpen}
                propsPatch={permission_level?.permission_level === 1 ? true : false}
                propsDelete={permission_level?.permission_level === 1 ? true : false}
                propsPost={permission_level?.permission_level === 1 ? true : false}
                propsWidth={1000}
                scroll={{
                    x: "100%",
                }}
                isMultipleEdit={false}
            />
        </Col>
    </Row>)

}
const QuestionAndAnswer = (
    permission_level = null,
) => {
    return (
        <Row
            gutter={[10, 20]}
            justify="space-around"
        >
            <Col span={24}>
                <QuestionAndAnswerTable permission_level={permission_level} />
            </Col>
        </Row>
    );
};
export { QuestionAndAnswerTable, QuestionAndAnswerAccordion }
export default QuestionAndAnswer;
